"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refactorQuery = void 0;
/**
 * Convert legacy keys to facilitate refactoring between
 * implementations. If a legacy key and target key are provided
 * we will assume the target key is the valid one.
 */
const refactorQuery = (req, refactorMap) => {
    const { nextUrl } = req;
    const cleanup = [];
    Object.keys(refactorMap).forEach(legacyKey => {
        const targetKey = refactorMap[legacyKey];
        if (nextUrl.searchParams.has(legacyKey) && !nextUrl.searchParams.has(targetKey)) {
            const legacyVal = nextUrl.searchParams.get(legacyKey);
            nextUrl.searchParams.set(targetKey, legacyVal);
            nextUrl.searchParams.delete(legacyKey);
            cleanup.push(legacyKey);
        }
        else if (nextUrl.searchParams.has(legacyKey) && nextUrl.searchParams.has(targetKey)) {
            nextUrl.searchParams.delete(legacyKey);
            cleanup.push(legacyKey);
        }
    });
    return cleanup.length !== 0;
};
exports.refactorQuery = refactorQuery;
exports.default = exports.refactorQuery;
